import type { ReactNode } from 'react';
import clsx from 'clsx';

type CardProps = {
  children: ReactNode;
  className?: string;
  crisp?: boolean;
  noise?: boolean;
  glow?: boolean;
};

export function Card({ children, className, crisp, noise, glow }: CardProps) {
  return (
    <div
      className={clsx(
        crisp ? 'surface-soft' : 'surface',
        noise && 'noise',
        glow && 'ring-brand',
        'p-5',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function CardHeader({
  kicker,
  title,
  description,
  actions,
  className,
}: {
  kicker?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={clsx('flex items-start justify-between gap-4 mb-5', className)}>
      <div className="min-w-0">
        {kicker && <div className="kicker kicker-brand mb-1.5">{kicker}</div>}
        <h2 className="text-[15px] font-semibold tracking-tight text-ink-800">{title}</h2>
        {description && <p className="text-[12.5px] text-ink-500 mt-1 max-w-prose">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
